import React from 'react'
import {useStyles, VideoCutSlider} from "./ScoredScenesSection.css";
import {StyledTableCell, StyledTableRow} from "../../../../commons/utils/table/StyledTableSecondary.css";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import ScoredSceneSummarySlider from "../utils/sliders/ScoredSceneSummarySlider";
import {useIntl} from "react-intl";

const ScoredScenesSectionOfGivenListSlim = ({scoredScenes}) => {
    const classes = useStyles();

    // Internationalization for simple strings
    const intl = useIntl();

    return (
        <Paper className={classes.root}>
            <TableContainer component={Paper}>
                <Table size="small">

                    {/* Table header */}
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align={"center"} width={"70%"} key='scoreSummary'>
                                {intl.formatMessage({
                                    id: 'app.scoredScene.overview.slim.table.column.scoreSummary',
                                    defaultMessage: 'Score Summary'
                                })}
                            </StyledTableCell>
                            <StyledTableCell align={"center"} width={"30%"} key='rangeOverivew'>
                                {intl.formatMessage({
                                    id: 'app.scoredScene.overview.slim.table.column.timeRange',
                                    defaultMessage: 'Time Range'
                                })}
                            </StyledTableCell>
                        </TableRow>
                    </TableHead>

                    {/* Table rows */}
                    <TableBody>
                        {scoredScenes.map((scoredScene) => {
                            return (
                                <StyledTableRow hover key={scoredScene.key}>

                                    {/* Score summary "slider" */}
                                    <StyledTableCell key='scoreSummary'>
                                        <div className={classes.scoreSummaryRow}>
                                            <ScoredSceneSummarySlider scoredScene={scoredScene} timeFormat="mm:ss:SS"/>
                                        </div>
                                    </StyledTableCell>
                                    <StyledTableCell key='timeRange'>
                                        <div className={classes.scoreSummaryRow}>
                                            <VideoCutSlider
                                                value={[scoredScene.basics.sceneStart, scoredScene.basics.sceneEnd]}
                                                valueLabelDisplay="off"
                                                min={0}
                                                max={scoredScene.video.vimeo.duration}
                                            />
                                        </div>
                                    </StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}
export default ScoredScenesSectionOfGivenListSlim
